'use client';
import React, { Component } from 'react';
import './style.sass';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';

class Investors extends Component {
    render() {
        return (
            <ScrollAnimation
                className="investors"
                animateIn="fadeIn"
                offset={100}
                animateOnce={true}
                duration={1.5}
            >
                <div className="full-wrapper">
                    <CommonTitle>Инвесторы</CommonTitle>
                    <div className="investors-bg">
                        <div className="investors-bg__title">О направлении:</div>
                        <div className="investors-bg__desc">
                            Для этого направления нужны были инвесторы молодые или уже матерые,
                            которым интересна IT сфера. Сообщество готово помочь найти
                            высокотехнологичные проекты и вместе с этим — прибыль.
                        </div>
                    </div>
                </div>

                <div className="starting">
                    <div className="full-wrapper">
                        <div className="starting__grid">
                            <div className="starting__number">1</div>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--img"
                            >
                                <div className="starting__img">
                                    <img
                                        src="/images/pic/adventureLand/starting/6.png"
                                        alt="Таргетированная реклама"
                                        loading="lazy"
                                    />
                                </div>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--text"
                            >
                                <div className="starting__content">
                                    <div className="starting__title">Первый запуск</div>
                                    <div className="starting__subtitle">
                                        Таргетированная реклама
                                    </div>
                                    <div className="starting__desc">
                                        <p>
                                            Ставку сделали на таргет в Facebook. Вели на сайт, где
                                            инвестор мог подписаться на рассылку. Но из информации
                                            на сайте было не понятно, что делать дальше. Мы выбрали
                                            новую конечную точку — посадочную лидформу. Но это тоже
                                            не принесло результата: новые инвесторы не знали, как
                                            и с кем им взаимодействовать.
                                        </p>
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className="starting starting--converse">
                    <div className="full-wrapper">
                        <div className="starting__grid">
                            <div className="starting__number">2</div>
                            <div className="starting__end" />
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--img"
                            >
                                <div className="starting__img">
                                    <img
                                        src="/images/pic/adventureLand/starting/7.png"
                                        alt="Редизайн сайта"
                                        loading="lazy"
                                    />
                                </div>
                            </ScrollAnimation>
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="starting__item starting__item--text"
                            >
                                <div className="starting__content">
                                    <div className="starting__title">Второй запуск</div>
                                    <div className="starting__subtitle">Редизайн сайта</div>
                                    <div className="starting__desc">
                                        <p>
                                            Мы приостановили РК, сделали редизайн сайта
                                            и посадочной, а главное — пояснили, что делать
                                            инвесторам. Для этого переделали посадочную с указанием
                                            предложения и выгод, СТА — заполнение расширенной
                                            формы-опроса. После изменений заново запустили таргет
                                            и получили заявки.
                                        </p>
                                    </div>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                </div>

                <div className="results-bg">
                    <div className="full-wrapper">
                        <ScrollAnimation
                            animateIn="fadeIn"
                            offset={50}
                            animateOnce={true}
                            duration={1}
                            className="results-bg__bot"
                        >
                            <div className="results-bg__bot-title">Результаты:</div>

                            <div className="results-bg__bot-desc">
                                В <b>2,5 раза</b> снижение стоимости заявки.
                            </div>
                            <div className="results-bg__bot-desc">
                                <b>Дальнейшая стратегия</b> — создание новой посадочной страницы
                                «Библиотека инвестора» и продвижение экспертизы проекты через нее,
                                работа с привлечением информационного трафика через поисковую
                                оптимизацию и СМИ.
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default Investors;
